import {FaBars} from 'react-icons/fa';
import {conversationDisplayName} from '../chatUtils';
import {ConversationIcon, presentConversationContext} from '../domain/conversationPresentation';
import ConnectionLabel from './ConnectionLabel';
import ChatNotificationButton from '../notifications/ChatNotificationButton';
import ConversationMembers from '../ConversationMembers';

export default function ChatHeader({conversation, currentUserId, connectionStatus, showSidebar, onOpenSidebar, renderActions}) {
    const context = presentConversationContext(conversation?.context);
    const ContextIcon = context?.Icon;
    return (
        <header className="chat-main-header">
            {showSidebar ? (
                <button type="button" className="chat-mobile-menu" aria-label="Open conversations" onClick={onOpenSidebar}><FaBars /></button>
            ) : null}
            <div className="chat-title">
                <h1>
                    {conversation ? <><ConversationIcon kind={conversation.kind} /> {conversationDisplayName(conversation, currentUserId)}</> : 'Chat'}
                </h1>
                {conversation ? <ConversationMembers key={`${currentUserId}:${conversation.id}`} conversation={conversation} currentUserId={currentUserId}/> : null}
            </div>
            {context ? (
                <span
                    className={`chat-context is-${context.status}`}
                    data-entity-type={context.entityType}
                    data-entity-key={context.entityKey}
                >
                    <ContextIcon aria-hidden="true" /> {context.label}
                </span>
            ) : null}
            {renderActions?.({conversation, context})}
            <ChatNotificationButton />
            <ConnectionLabel status={connectionStatus} />
        </header>
    );
}
